import { render, staticRenderFns } from "./CopyAllDripsNew.vue?vue&type=template&id=42664dad&scoped=true&"
import script from "./CopyAllDripsNew.vue?vue&type=script&lang=js&"
export * from "./CopyAllDripsNew.vue?vue&type=script&lang=js&"
import style0 from "./CopyAllDripsNew.vue?vue&type=style&index=0&id=42664dad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42664dad",
  null
  
)

export default component.exports